/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TypeInputs */

const de__field_type = /** @type {(inputs: _Field_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

/**

* @param {_Field_TypeInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_type = /** @type {((inputs?: _Field_TypeInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TypeInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_type(inputs)
});